// CANVAS VIEW PREFERENCES (RS lane, owner directive 2026-07-21: "scrollbars
// on the work surface, as well as rulers (enabled or removed by a setting for
// the ruler along with units)").
//
// Machine-local USER PREFERENCE, not design data — same law as the snapping
// toggle ('cce_snapping'): lives in localStorage, never in the design JSON,
// never an undo entry. One module-level store so the two consumers — the
// AppBar gear flyout (writes) and the CanvasViewport chrome (reads) — share
// truth without threading props through the shared editor files.
//
// Slot: pseCanvasPrefs.v1  { rulers: boolean, units: 'in'|'cm'|'px' }
// Defaults: rulers ON, units inches (print-first product; the Poster
// flyout's size fields stay inches regardless — that's the print contract,
// units here affect the RULERS only).

import { useSyncExternalStore } from 'react';

const STORAGE_KEY = 'pseCanvasPrefs.v1';
const UNITS = ['in', 'cm', 'px'];
const DEFAULTS = { rulers: true, units: 'in' };

const sanitize = (raw) => ({
  rulers: typeof raw?.rulers === 'boolean' ? raw.rulers : DEFAULTS.rulers,
  units: UNITS.includes(raw?.units) ? raw.units : DEFAULTS.units,
});

const load = () => {
  try {
    return sanitize(JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null'));
  } catch (_) {
    return { ...DEFAULTS };
  }
};

let prefs = load();
const subscribers = new Set();

export function getCanvasPrefs() {
  return prefs;
}

export function setCanvasPrefs(patch) {
  prefs = sanitize({ ...prefs, ...patch });
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
  } catch (_) { /* private-mode etc. — prefs still live for the session */ }
  subscribers.forEach((fn) => {
    try { fn(prefs); } catch (_) { /* one bad listener must not mute the rest */ }
  });
}

export function subscribeCanvasPrefs(fn) {
  subscribers.add(fn);
  return () => subscribers.delete(fn);
}

/** React mirror — reference-stable snapshot until the next setCanvasPrefs. */
export function useCanvasPrefs() {
  return useSyncExternalStore(subscribeCanvasPrefs, getCanvasPrefs);
}
